export enum MandatePermissions {
    viewVisiFlag = 'VIEW_VISI_FLAG',
    updateVisiFlag = 'UPDATE_VISI_FLAG',
    deletePrescription = 'DELETE_PRESCRIPTION',
    consultDiaryNotes = 'CONSULT_DIARY_NOTES',
    consultMedicationScheme = 'CONSULT_MEDICATION_SCHEME',
    reservePrescription = 'RESERVE_PRESCRIPTION',
    viewReservationFlag = 'VIEW_RESERVATION_FLAG',
    consultPrescriptions = 'CONSULT_PRESCRIPTIONS',
    consultDeliveredMedications = 'CONSULT_DELIVERED_MEDICATIONS'
}
